export default "__VITE_ASSET__BzNUGh6O__"